import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import './VendorLayout.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const VendorLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [vendor, setVendor] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const vendorToken = localStorage.getItem('vendorToken');
    const vendorInfo = localStorage.getItem('vendorInfo');

    if (!vendorToken || !vendorInfo) {
      navigate('/vendor/login');
      return;
    }

    setVendor(JSON.parse(vendorInfo));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('vendorToken');
    localStorage.removeItem('vendorInfo');
    localStorage.removeItem('userType');
    navigate('/vendor/login');
  };

  const menuItems = [
    { path: '/vendor/dashboard', icon: 'fas fa-home', label: 'Dashboard' },
    { path: '/vendor/tasks', icon: 'fas fa-tasks', label: 'Tasks' },
    { path: '/vendor/issues', icon: 'fas fa-exclamation-circle', label: 'Issues' },
    { path: '/vendor/contracts', icon: 'fa-solid fa-file-contract', label: 'Contracts' },
    { path: '/vendor/time-tracking', icon: 'fas fa-clock', label: 'Time Tracking' },
    { path: '/vendor/co-vendors', icon: 'fas fa-users', label: 'Staff' },
    // { path: '/vendor/portal', icon: 'fas fa-comments', label: 'Messages' },
    { path: '/vendor/profile', icon: 'fas fa-user', label: 'Profile' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="vendor-layout">
      {/* Sidebar */}
      <aside className={`vendor-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo">
            <i className="fas fa-building"></i>
            {sidebarOpen && <span>Tenant Portal</span>}
          </div>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? <FaChevronLeft /> : <FaChevronRight />}
          </button>
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            <i className="fas fa-building"></i>
          </div>
          {sidebarOpen && (
            <div className="user-info">
              <div className="user-name">{vendor?.vendor?.company_name}</div>
              <div className="user-code">{vendor?.vendor?.vendor_code}</div>
            </div>
          )}
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              title={!sidebarOpen ? item.label : ''}
            >
              <i className={item.icon}></i>
              {sidebarOpen && <span>{item.label}</span>}
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button 
            className="logout-btn"
            onClick={handleLogout}
            title={!sidebarOpen ? 'Logout' : ''}
          >
            <i className="fas fa-sign-out-alt"></i>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="vendor-main">
        <Outlet />
      </main>
    </div>
  );
};

export default VendorLayout;

